import { render } from "./foother.vue?vue&type=template&id=66603a7d"
import script from "./foother.vue?vue&type=script&lang=js"
export * from "./foother.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__